// @flow

// Effect Manager
import { fork } from 'redux-saga/effects'

// Sagas
import watchCommentsOperations from './operations'
import { watchOperations } from 'hfty-operator-comments'

// Selectors
import operations$ from '../selectors/operations'

export default function *main (): Generator<*, void, *> {
  yield fork(watchCommentsOperations)
  yield fork(watchOperations, { operations$ })
}
